import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { CustomGraph } from './atoms';

const wrapperTemplate = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export default Molecule({
  template: wrapperTemplate,
  type: 'formgroup',
  atoms: [
    {
      component: CustomGraph,
      name: 'CustomGraph',
      displayValue: ({ color, graphData, avgColor, height, maxsize, multiple, title  }) => {
        const _onChange = ({ handle }, o) => handle(o)
        return {
          color,
          graphData,
          _onChange,
          // new property for the colors of the average
          avgColor,
          height,
          maxsize,
          onChangeField: 'onElementClick',
          multiple, 
          title 
        }
      }
    }
  ]
})
